'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = MediaGallery;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _masonryLayout = require('masonry-layout');

var _masonryLayout2 = _interopRequireDefault(_masonryLayout);

function MediaGallery() {

	_pubsub2['default'].on('loader:hide', function () {
		var elems = document.querySelectorAll('.media_list');
		if (!elems) return;

		for (var index = 0; index < elems.length; index++) {
			var elem = elems[index];
			var msnry = new _masonryLayout2['default'](elem, {
				// options
				itemSelector: '.media_list_item',
				percentPosition: true,
				horizontalOrder: true,
				gutter: 40,
				stagger: 50
			});
		}
	});
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL21lZGlhLWdhbGxlcnkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7cUJBS3dCLFlBQVk7Ozs7b0JBTG5CLE1BQU07Ozs7c0JBQ0osUUFBUTs7Ozs2QkFDUCxnQkFBZ0I7Ozs7QUFHckIsU0FBUyxZQUFZLEdBQUc7O0FBRXRDLHFCQUFPLEVBQUUsQ0FBQyxhQUFhLEVBQUUsWUFBVTtBQUNsQyxNQUFJLEtBQUssR0FBRyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxDQUFDLENBQUM7QUFDckQsTUFBRyxDQUFDLEtBQUssRUFBRSxPQUFPOztBQUVsQixPQUFLLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRSxLQUFLLEdBQUcsS0FBSyxDQUFDLE1BQU0sRUFBRSxLQUFLLEVBQUUsRUFBRTtBQUNsRCxPQUFNLElBQUksR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDMUIsT0FBSSxLQUFLLEdBQUcsK0JBQWEsSUFBSSxFQUFFOztBQUU5QixnQkFBWSxFQUFFLGtCQUFrQjtBQUNoQyxtQkFBZSxFQUFFLElBQUk7QUFDckIsbUJBQWUsRUFBRSxJQUFJO0FBQ3JCLFVBQU0sRUFBRSxFQUFFO0FBQ1YsV0FBTyxFQUFFLEVBQUU7SUFDWCxDQUFDLENBQUM7R0FDSDtFQUNELENBQUMsQ0FBQztDQUNIIiwiZmlsZSI6Ii9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL21lZGlhLWdhbGxlcnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ3NhcCBmcm9tICdnc2FwJztcbmltcG9ydCBwdWJzdWIgZnJvbSAncHVic3ViJztcbmltcG9ydCBNYXNvbnJ5IGZyb20gJ21hc29ucnktbGF5b3V0JztcblxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBNZWRpYUdhbGxlcnkoKSB7XG5cblx0cHVic3ViLm9uKCdsb2FkZXI6aGlkZScsIGZ1bmN0aW9uKCl7XG5cdFx0dmFyIGVsZW1zID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvckFsbCgnLm1lZGlhX2xpc3QnKTtcblx0XHRpZighZWxlbXMpIHJldHVybjtcblxuXHRcdGZvciAobGV0IGluZGV4ID0gMDsgaW5kZXggPCBlbGVtcy5sZW5ndGg7IGluZGV4KyspIHtcblx0XHRcdGNvbnN0IGVsZW0gPSBlbGVtc1tpbmRleF07XG5cdFx0XHR2YXIgbXNucnkgPSBuZXcgTWFzb25yeSggZWxlbSwge1xuXHRcdFx0XHQvLyBvcHRpb25zXG5cdFx0XHRcdGl0ZW1TZWxlY3RvcjogJy5tZWRpYV9saXN0X2l0ZW0nLFxuXHRcdFx0XHRwZXJjZW50UG9zaXRpb246IHRydWUsIFxuXHRcdFx0XHRob3Jpem9udGFsT3JkZXI6IHRydWUsXG5cdFx0XHRcdGd1dHRlcjogNDAsXG5cdFx0XHRcdHN0YWdnZXI6IDUwXG5cdFx0XHR9KTtcblx0XHR9XG5cdH0pO1xufVxuIl19